import { render, staticRenderFns } from "./OkSelect.vue?vue&type=template&id=5a6ad70c&"
import script from "./OkSelect.vue?vue&type=script&lang=js&"
export * from "./OkSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports